<script lang="ts">
  import type { Store } from "../../Logic/UIEventSource"

  /**
   * in pixels
   */
  export let height: Store<number>
  export let clss: string = ""
</script>

<div class={clss + " shrink-0"} style={"height: " + $height + "px"} />
